module.exports = __webpack_public_path__ + "static/media/moviedb-logo.61ff80a8.svg";